export default {
  header: {
    recommend: 'Wir empfehlen dir dazu',
  },
  skip_checkout_button: {
    go_to_checkout: 'Nein, mit Bestellung fortfahren',
  },
};
